<template>
  <div class='wrap'>
    <div class='card-wrap'>
      <el-card class="box-card">
      <el-form :model='form' >
        <el-form-item label='' class="info" >
          <span>姓名</span><el-input v-model='form.username' placeholder='请输入用户名'></el-input>
        </el-form-item>
        <el-form-item label='' class="info">
          <span>公司</span><el-input v-model='form.company' placeholder='请输入公司名称' type=""></el-input>
        </el-form-item>
         <el-form-item label='' class="info">
          <span>邮箱</span><el-input v-model='form.email' placeholder='请输入邮箱' type=""></el-input>
        </el-form-item>
         <el-form-item label='' class="info">
          <span>手机号</span><el-input v-model='form.phone' placeholder='请输入手机号' type=""></el-input>
        </el-form-item>
         <el-form-item label='' class="info">
          <span>验证码</span><el-input v-model='form.verification' placeholder='请输入验证码' type=""></el-input>
          <div class="verification">发送验证码</div>
        </el-form-item>
         <el-form-item label='' class="agree">
           <el-checkbox v-model="checked"></el-checkbox><span>同意《XX条文》</span>
        </el-form-item>
        <el-form-item label='' class="info">
          <el-button type='primary' class="registe" @click="submit">注册</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    </div>

  </div>
</template>

<script>
import { isMobile,isEmail } from '../util/validator.js';
export default {
  name: 'registered',
  data () {
    return {
      form:{
        username:''
      },
      checked: true
    }
  },
  mounted() {
    console.log(this.$store.state)
  },
  methods: {
    submit() {
      if (!isMobile(this.form.phone)) {
        this.$message({
          message: "请您输入正确的手机号",
          type: "warning"
        });
        return;
      }
      if (!isEmail(this.form.email)) {
        this.$message({
          message: "请您输入正确格式的邮箱",
          type: "warning"
        });
        return;
      }
      console.log(this.form)
    }
  }
  
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrap{
      background: #29394e;
      height: 100%;
      padding-top: 50px;
  }
  .box-card{
    width: 400px;
    margin: 0 auto
  }
  .info .el-form-item__content{
    display: flex !important
  }
  .info .el-form-item__content span{
    flex: 1
  }
  .info .el-form-item__content .el-input{
    flex: 4
  }
  .verification{
    position: absolute;
    right: 15px;
    color: #0066CC
  }
  .registe{
    margin: 0 auto;
    width: 50%;
  }
  .agree{
    color: #0066CC
  }
  .agree .el-form-item__content{
      text-align: center;
  }
  .agree .el-checkbox__inner{
    border: 1px solid #0066CC
  }
</style>



// WEBPACK FOOTER //
// src/components/registered.vue